/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ items: NonNullable<unknown> }} Spaces_Toast_Deleted_Items_SuccessInputs */



/**
* | output |
* | --- |
* | "Successfully deleted {items}" |
*
* @param {Spaces_Toast_Deleted_Items_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_deleted_items_success = /** @type {((inputs: Spaces_Toast_Deleted_Items_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_Deleted_Items_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.items} erfolgreich gelöscht`)
	return /** @type {LocalizedString} */ (`Successfully deleted ${i?.items}`)
});